import './scripts/common';
import {onFind} from '@elements/init-modules-in-scope';
import {find} from '@elements/dom-utils';

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

// Todo: Add page specific JS here e.g:
import * as lightbox from '@elements/lightbox';
lightbox.init({
        plugins: ['zoom', 'video'],
        zoom: true,
        video: true
    }
);


import * as video from './scripts/video';
video.init();

import * as imageSlider from './scripts/image-slider';
imageSlider.init();

import * as eventCardTeaserSlider from './scripts/event-card-teaser-slider';
eventCardTeaserSlider.init();

import * as eventImgTeaserSlider from './scripts/event-img-teaser-slider';
eventImgTeaserSlider.init();

import * as dynamicLightbox from './scripts/dynamic-lightbox';
dynamicLightbox.init();

import * as affix from './scripts/elements-packages/affix';
affix.createAffix(find('.js-affix-sidebox'), {mediaQuery: '(min-width: 768px)'}, {
    base: '.js-affix-sidebox',
    placeholder: '.js-affix-sidebox__placeholder',
    container: '.js-affix-sidebox__container'
});

import * as ajaxForm from '@elements/ajax-form';
ajaxForm.init();

import * as ajaxFormExtend from './scripts/ajax-form-extend';
ajaxFormExtend.init();

import * as triggerSubmit from './scripts/trigger-submit';
triggerSubmit.init();


import * as datepicker from "@elements/datepicker";
datepicker.init();

import * as datepickerRange from "@elements/datepicker-range";
datepickerRange.init();

import * as productGrid from '@elements/product-grid';
productGrid.init();

import * as fadeIn from "./scripts/fade-in";
fadeIn.init();


import * as parallax from "./scripts/parallax";
parallax.init();

import * as filter from "./scripts/filter.js";
filter.init();
